import { useMediaQuery } from '@mantine/hooks';
import React, { useEffect, useMemo, useState } from 'react';
import Navigation from '../sidebar/Navigation';
import './MyVendorInquiryDetails.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { createB2BAPI } from '../../../api/Interceptor';
import { BASE_URL } from '../../../api/EndPoints';
import { useNavigate } from 'react-router-dom';
import { Carousel } from '@mantine/carousel';
import { Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

const MyVendorInquiryDetails = () => {
    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const isMobileOrTablet = useMediaQuery('(max-width: 991px)');
    const isLaptop = useMediaQuery('(min-width: 992px)');
    const [showInquiryDetails, setShowInquiryDetails] = useState(false);
    const [inquiryData, setInquiryData] = useState(null);
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    useEffect(() => {
        fetchFabricData();
    }, []);

    const fetchFabricData = async () => {
        try {
            const res = await B2B_API.get(`inquiryProduct/get/${id}`).json();
            setInquiryData(res.response);
        } catch (error) {
            console.error('Error fetching fabricInquiry:', error);
        }
    };

    const handleViewInquiryClick = () => {
        setShowInquiryDetails(true);
    };

    const handleCloseClick = () => {
        setShowInquiryDetails(false);
    };

    const renderTimeline = () => (
        <div className="vid-timeline-card">
            <div className="vid-timeline-title">
                <div className="vid-timeline-dot"></div>
                Development submitted
            </div>
            <div className="vid-timeline-date">
                {formatDate(inquiryData?.createdDate)}
            </div>
        </div>
    );

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }

    return (
        <div className="view-my-page router-view-container">
            {!isMobileOrTablet && <Navigation />}
            <div className="view-fabric-inquiry-detail-v2 route-view">
                <div className="top" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >
                    <div>
                        <b style={{color:"#8BC54F"}}>Product Name</b>
                        <div className="page-titless">{inquiryData?.articleName}</div>
                        <div className="status-container">
                            {isMobileOrTablet && !showInquiryDetails && (
                                <button className="btns btn-view-inquirys" onClick={handleViewInquiryClick}>
                                    VIEW INQUIRY
                                </button>
                            )}
                        </div>
                    </div>
                    <Button
                        color='#8BC54F'
                        onClick={() => navigate("/vendorFabricInquiries")}
                        leftSection={<IconArrowLeft stroke={2} />}
                    >
                        Back
                    </Button>
                </div>

                <div className="vid-content-wrapper" style={{ marginTop: '24px' }}>
                    <div className="vid-left">
                        {renderTimeline()}
                    </div>

                    {isMobileOrTablet && (
                        <div 
                            className={`vid-overlay ${showInquiryDetails ? 'show' : ''}`} 
                            onClick={handleCloseClick}
                        />
                    )}

                    <div className={`vid-details-card ${showInquiryDetails && isMobileOrTablet ? 'open' : ''}`} style={{ display: inquiryData ? 'block' : 'none' }}>
                        {inquiryData && (
                            <>
                                <div className="vid-details-header">
                                    <div>
                                        <div className="vid-details-title">My Development</div>
                                    </div>
                                    {isMobileOrTablet && (
                                        <FontAwesomeIcon
                                            icon={faXmark}
                                            className="vid-close-btn"
                                            onClick={handleCloseClick}
                                        />
                                    )}
                                </div>
                                <div className="vid-details-date">Submitted on {formatDate(inquiryData?.createdDate)}</div>

                                {inquiryData?.vendorImages?.length > 0 && (
                                    <div className="vid-image-section">
                                        <div className="vid-image-title">Images</div>
                                        <div className="vid-image-carousel">
                                            <Carousel
                                                withIndicators
                                                slideSize="100%"
                                                align="start"
                                                withControls={inquiryData.vendorImages.length > 1}
                                                loop
                                                styles={{
                                                    indicator: {
                                                        width: 8,
                                                        height: 8,
                                                        backgroundColor: "#888",
                                                    },
                                                }}
                                            >
                                                {inquiryData.vendorImages.map((img, index) => (
                                                    <Carousel.Slide key={index}>
                                                        <div className="pv-carousel-inner">
                                                            <img
                                                                src={`${BASE_URL.replace("/api", "")}${img}?time=${Date.now()}`}
                                                                alt={`vendor-${index}`}
                                                                className="vid-carousel-img"
                                                            />
                                                        </div>
                                                    </Carousel.Slide>
                                                ))}
                                            </Carousel>
                                        </div>
                                    </div>
                                )}

                                <div className="vid-info-grid">
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">Product Id</div>
                                        <div className="vid-info-value">{inquiryData?.articleCode || "-"}</div>
                                    </div>
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">Product Name</div>
                                        <div className="vid-info-value">{inquiryData?.articleName || "-"}</div>
                                    </div>
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">Weight</div>
                                        <div className="vid-info-value">{inquiryData?.metrics?.weight || "-"}</div>
                                    </div>
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">Width</div>
                                        <div className="vid-info-value">{inquiryData?.metrics?.width || "-"}</div>
                                    </div>
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">Commission %</div>
                                        <div className="vid-info-value">{inquiryData?.vendorProductInfo?.commissionPercentage || "-"}</div>
                                    </div>
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">Fiber Composition</div>
                                        <div className="vid-info-value">{Object.entries(inquiryData?.fabricContent?.composition || {})
                                            .map(([key, value]) => `${key} ${value}%`)
                                            .join(" / ") || "-"}</div>
                                    </div>
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">UOM</div>
                                        <div className="vid-info-value">{inquiryData?.otherInformation?.unitOfMeasures?.isMeter ? "Meter" : inquiryData?.otherInformation?.unitOfMeasures?.isKg ? "Kg" : inquiryData?.otherInformation?.unitOfMeasures?.isYard ? "Yard" : "-"}</div>
                                    </div>
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">Fiber</div>
                                        <div className="vid-info-value">{inquiryData?.fiber ?? '-'}</div>
                                    </div>
                                    <div className="vid-info-item">
                                        <div className="vid-info-label">Price</div>
                                        <div className="vid-info-value">₹{inquiryData?.vendorProductInfo?.costPrice || "-"}</div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyVendorInquiryDetails;
